import { Api } from "../config/request";

const getMessages = async (data) =>{
    let response= await Api.PostRequest("/getMessages", data);
    return response.data;
}
const sendMessage = async (data) =>{
    let response= await Api.PostRequest("/sendMessage", data);
    return response.data;
}

const getLeaderboardDetails= async (data) =>{
    let response = await Api.PostRequest("/getGameTokenLeaderboardList", data);
    return response.data;
}

const getAllLeaderboardDetails= async (data) =>{
    let response = await Api.PostRequest("/getGameAllTokenLeaderboardList", data);
    return response.data;
}

const uploadMediaInLiveGame = async (data, onProgress) => {
    let response = await Api.PostFileRequest("/uploadMediaInLiveGame", data, onProgress);
    return response.data;
}

const deleteLiveGameMedia = async (data) => {
    let response = await Api.PostRequest("/deleteLiveGameMedia", data);
    return response.data;
}

const getLiveGameMediaList = async (data) => {
    let response = await Api.PostRequest("/liveGameMediaList", data);
    return response.data;
}

const getGameActionsListCorrespondingToZone = async (data) => {
    let response = await Api.PostRequest("/getGameActionsListCorrespondingToZone", data);
    return response.data;
}

const restartGame = async (data) => {
    let response = await Api.PostRequest("/restartGame", data);
    return response.data;
}

const liveGameApi ={
    getMessages,
    sendMessage,
    getLeaderboardDetails,
    uploadMediaInLiveGame,
    deleteLiveGameMedia,
    getLiveGameMediaList,
    restartGame,
    getAllLeaderboardDetails,
    getGameActionsListCorrespondingToZone
}

export default liveGameApi;